export default __webpack_public_path__ + "static/media/screen2.f1a5eb36.png";